<mat-tab-group mat-align-tabs="center" [selectedIndex]="index">
    <mat-tab label="Liste d'appels"><app-calls-list (openCalls)="addTab($event)"></app-calls-list></mat-tab>
    <mat-tab *ngFor="let tab of tabs; let index = index">
        <ng-template mat-tab-label>
            <span>{{tab.title}}</span>
            <button mat-icon-button class="close-btn" (click)="closeTab(index)"> <mat-icon>close</mat-icon> </button>
        </ng-template>
        <ng-container *ngIf="tab.mode=='read'; else newCall">
            <app-call [suiviId]="tab.id_suivi" (editCall)="changeTab($event,index)"></app-call>
        </ng-container>
        <ng-template #newCall>
            <app-new-call [suiviId]="tab.id_suivi"></app-new-call>
        </ng-template>
        

    </mat-tab>
</mat-tab-group>